export default "__VITE_ASSET__mOx5DWW1__"